import React, { Component } from "react";
import { isEqual } from "lodash";
import { merge } from "lodash";
import { Chart, setHighcharts } from "@highcharts/react";
import Highcharts from "highcharts";

setHighcharts(Highcharts);

import { chartColors } from "utils/highcharts/config";

// Derived from PropTypes: extendedConfig was PropTypes.shape({}) (a Highcharts
// options override merged in last) and chartData was
// PropTypes.arrayOf(PropTypes.shape({})) (the chart's series array). Both are
// optional (no .isRequired; extendedConfig has a defaultProp of {}).
interface PieChartProps {
  extendedConfig?: Highcharts.Options;
  chartData?: Highcharts.SeriesOptionsType[];
}

// No this.state / setState in this component; state shape is empty.
type PieChartState = Record<string, never>;

class PieChart extends Component<PieChartProps, PieChartState> {
  static defaultProps = {
    extendedConfig: {},
  };

  shouldComponentUpdate(nextProps: PieChartProps) {
    const configChanged = !isEqual(
      nextProps.extendedConfig,
      this.props.extendedConfig
    );
    const chartDataChanged = !isEqual(
      nextProps.chartData,
      this.props.chartData
    );
    return configChanged || chartDataChanged;
  }

  _buildChartConfig(): Highcharts.Options {
    return merge(
      {},
      {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          style: {
            fontFamily:
              '"Graphik", "Open Sans", "Helvetica Neue", Arial, sans-serif',
          },
        },
        colors: chartColors,
        title: {
          text: "",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        series: this.props.chartData,
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.percentage:.1f} %",
            },
          },
        },
      },
      this.props.extendedConfig
    );
  }

  render() {
    return (
      <div>
        <Chart options={this._buildChartConfig()} />
      </div>
    );
  }
}

export default PieChart;
